import { useState, useEffect } from "preact/hooks";

export function usePromise<T>(promiseCreator: () => Promise<T>, deps: any[] = []) {
    const [result, setResult] = useState<T | null>(null);
    useEffect(() => {
        let stillGood = true;
        promiseCreator().then(result => {
            if (stillGood) setResult(result);
        });
        return () => { stillGood = false; };
    }, deps);
    return result;
}